import { Injectable, inject } from '@angular/core';
import { GoogleAnalyticsService } from '@shared-services/google-analytics.service';

@Injectable({
  providedIn: 'root' // Single instance provided in root
})
export class InitialiseService {

  private googleAnalyticsService = inject(GoogleAnalyticsService);

  constructor() { }

  // Called at application startup e.g. page load
  initialise(): void {
    // Check for Google Analytics ClientId
    this.googleAnalyticsService?.checkForClientId();
  }
}
